import React, { useEffect, useState, useCallback } from "react";
import { Button } from "../../ui/button";
import Loader from "../../Loader/Loader";
import { getBankDataTeacherbyID } from "../../../provider/adm/profesores/BankData/getBankData";
import { postBankData } from "../../../provider/adm/profesores/BankData/postBankData";
import { putBankData } from "../../../provider/adm/profesores/BankData/PutBankData";
import { getTimeValue } from "../../../provider/adm/profesores/BankData/TimeValue/getTimeValue";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../ui/select";
import TimeValueCRUD from "./TimeValueCRUD";

const CrearEditarProfesorBankData = ({ personal_info_teacher }) => {
  const [bankdata, setBankData] = useState(null);
  const [contractCity, setContractCity] = useState("");
  const [bankAccountNumber, setBankAccountNumber] = useState("");
  const [selectedBankId, setSelectedBankId] = useState("");
  const [loading, setLoading] = useState(false);
  const [banks, setBanks] = useState([]);

  // TimeValue states
  const [timeValues, setTimeValues] = useState([]);
  const [selectedTimeValueId, setSelectedTimeValueId] = useState("");
  const [selectedTimeValueName, setSelectedTimeValueName] = useState("");
  const fetchBanks = async () => {
    try {
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/profesorbanco/bancos`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        }
      });
      const data = await response.json();
      setBanks(data);
    } catch (error) {
      console.error("Error fetching banks:", error);
    }
  };
  const fetchTimeValues =async () => {
    try {
      const data = await getTimeValue();
      setTimeValues(data);
    } catch (error) {
      console.error("Error fetching time values:", error);
    }
  };
  const fetchBankData = async () => {
    try {
      const data = await getBankDataTeacherbyID(personal_info_teacher.id);
      setBankData(data);

      // Set timeValue information if exists
      if (data && data.timeValue) {
        setSelectedTimeValueId(data.timeValue.id);
        setSelectedTimeValueName(data.timeValue.name);
      }
    } catch (error) {
      console.error("Error fetching bank data:", error);
    }
  };
  // Fetch time values
  useEffect(() => {
    fetchTimeValues();
    fetchBanks();
    fetchBankData();
  }, []);

  useEffect(() => {
    if (bankdata) {
      setContractCity(bankdata.contractCity || "");
      setBankAccountNumber(bankdata.bankAccountNumber || "");
      setSelectedBankId(bankdata.bank?.id || "");

      // Update this part to use the correct structure
      if (bankdata.timeValue) {
        setSelectedTimeValueId(bankdata.timeValue.id);
        setSelectedTimeValueName(bankdata.timeValue.name);
      }
    }
  }, [bankdata, timeValues]);

  const validateFields = () => {
    if (
      !contractCity ||
      !bankAccountNumber ||
      !selectedBankId ||
      !selectedTimeValueId
    ) {
      alert("Please fill in all required fields.");
      return false;
    }
    return true;
  };

  const handleSave = async () => {
    if (!validateFields()) return;

    if (window.confirm("Are you sure you want to save the changes?")) {
      setLoading(true);
      console.log(selectedTimeValueId)
      const formattedData = {
        contractCity,
        timeValueId: parseInt(selectedTimeValueId),
        bankAccountNumber,
        bankId: parseInt(selectedBankId),
        teacherId: personal_info_teacher.id,
      };

      try {
        if (bankdata && bankdata.id) {
          await putBankData(formattedData);
        } else {
          await postBankData(formattedData);
        }
      } catch (error) {
        console.error("Error saving bank data:", error);
      } finally {
        fetchTimeValues();
        fetchBankData();
        setLoading(false);
      }
    }
  };
  const selectedTimeValue = timeValues.find(tv => tv.id === parseInt(selectedTimeValueId));
  const formatNumber = (value) => {
    if (!value) return "";
    // Remove non-digit characters
    const number = value.toString().replace(/\D/g, "");
    // Format with thousands separator
    return new Intl.NumberFormat('es-CO').format(number);
  };
  return (
    <>
      {loading && <Loader />}
      <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Ciudad de Contrato
          </label>
          <input
            type="text"
            value={contractCity}
            onChange={(e) => setContractCity(e.target.value)}
            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            placeholder="Enter contract city"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Numero de cuenta
          </label>
          <input
            type="text"
            value={bankAccountNumber}
            onChange={(e) => setBankAccountNumber(e.target.value)}
            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            placeholder="Enter bank account number"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Nombre del banco
          </label>
          <Select
            value={selectedBankId.toString()}
            onValueChange={(value) => setSelectedBankId(value)}
          >
            <SelectTrigger className="w-full">
              <SelectValue placeholder="Seleccionar banco" />
            </SelectTrigger>
            <SelectContent className="h-40">
              {banks.map((bank) => (
                <SelectItem key={bank.id} value={bank.id.toString()}>
                  {bank.bankName} ({bank.location})
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {/* TimeValue CRUD Component */}
        <TimeValueCRUD
          timeValues={timeValues}
          selectedTimeValueId={selectedTimeValueId}
          setSelectedTimeValueId={setSelectedTimeValueId}
          selectedTimeValueName={selectedTimeValueName}
          setSelectedTimeValueName={setSelectedTimeValueName}
          loading={loading}
          setLoading={setLoading}
          fetchTimeValues={fetchTimeValues}
        />

        {selectedTimeValue && (
          <div className="border p-4 rounded-md bg-gray-50">
            <h3 className="font-medium mb-2">Información de nómina seleccionada:</h3>
            <p><span className="font-medium">Nombre:</span> {selectedTimeValue.name}</p>
            <p><span className="font-medium">Valor hora virtual:</span> ${formatNumber(selectedTimeValue.virtualHourValue)}</p>
            <p><span className="font-medium">Valor hora presencial:</span> ${formatNumber(selectedTimeValue.inpersonHourValue)}</p>
            <p><span className="font-medium">Valor hora virtual cancelada:</span> ${formatNumber(selectedTimeValue.virtualHourCancelledValue)}</p>
            <p><span className="font-medium">Valor hora presencial cancelada:</span> ${formatNumber(selectedTimeValue.inpersonHourCancelledValue)}</p>
          </div>
        )}

        <div className="pt-4">
          <Button
            className="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 rounded-md"
            onClick={handleSave}
          >
            Save
          </Button>
        </div>
      </form>
    </>
  );
};

export default CrearEditarProfesorBankData;
